import { themedUseStyletron } from '../../../theme/customTheme'
import { IWindowContact } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { Icon } from './Icon';
import { SmallPanel } from './SmallPanel';
import { Badge } from 'baseui/badge';
import { FormattedMessage } from 'react-intl';

export function OverviewPanel(props: IWindowContact) {
    const [, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper  height={theme.appSizes.smallAppHeight} icon={<Icon schema={props.schema} color={theme.colors.backgroundPrimary} size='100%' />} {...props}>
            <SmallPanel {...props}></SmallPanel>
            {!props.isOpen &&
                <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.CLOSED" defaultMessage="CLOSED" />} />
            }
        </OverviewPanelWrapper>
    );
}